import { useIsSuperAdmin } from '../hooks/useIsSuperAdmin';
import { useUserSetting } from '../userSettings/useUserSetting';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { useCallback } from 'react';
import { Text } from 'foundations-components/components/Text';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useHasCardV2 } from 'crm-object-board-core/hooks';
import { Image } from 'foundations-components/transitional/components/Image';
//@ts-expect-error untyped
import welcomeDialogImage from 'bender-url!crm-object-board-card/images/Illustration.png';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { useOpenCardSettingsPanel } from '../providers/settings/CardSettingsPanelProvider';
import { HAS_SEEN_WELCOME_DIALOG } from '../userSettings/UserSettingKeys';
import { useSetUserSetting } from '../userSettings/useSetUserSetting';
import Raven from 'raven-js';
import { isAcceptanceTestEnvironment } from '../utils/isAcceptanceTestEnvironment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isAT = isAcceptanceTestEnvironment();
export const CrmObjectBoardCardWelcomeDialog = ({
  onClose,
  userOnly = true
}) => {
  const isAdmin = useIsSuperAdmin() && !userOnly;
  const openCardSettings = useOpenCardSettingsPanel();
  const handleAction = useCallback(() => {
    openCardSettings(isAdmin ? 'admin' : 'user', 'board');
    onClose();
  }, [openCardSettings, isAdmin, onClose]);
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 634,
    "data-test-id": "crm-object-board-card-welcome-dialog",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        typography: "heading-600",
        textAlign: "center",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.welcomeDialog.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      textAlign: "left",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(Image, {
        src: welcomeDialogImage
      }), /*#__PURE__*/_jsxs(List, {
        styled: true,
        marginBlockStart: "400",
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `crmObjectBoardCard.welcomeDialog.${isAdmin ? 'admin' : 'user'}.description`
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `crmObjectBoardCard.welcomeDialog.${isAdmin ? 'admin' : 'user'}.description2`
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `crmObjectBoardCard.welcomeDialog.${isAdmin ? 'admin' : 'user'}.description3`
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleAction,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `crmObjectBoardCard.welcomeDialog.${isAdmin ? 'admin' : 'user'}.action`
        })
      })
    })]
  });
};
export const CrmObjectBoardCardWelcomeDialogWithUserSetting = () => {
  const hasCardV2 = useHasCardV2();
  const hasSeenWelcomeDialog = useUserSetting(HAS_SEEN_WELCOME_DIALOG);
  const setHasSeenWelcomeDialog = useSetUserSetting();
  const handleClose = useCallback(() => {
    setHasSeenWelcomeDialog({
      variables: {
        key: HAS_SEEN_WELCOME_DIALOG,
        value: true
      }
    }).catch(e => {
      Raven.captureException(new Error('Error setting user setting', {
        cause: e
      }), {
        extra: {
          variables: {
            key: HAS_SEEN_WELCOME_DIALOG,
            value: true
          }
        }
      });
    });
  }, [setHasSeenWelcomeDialog]);
  if (!hasCardV2) {
    return null;
  }
  if (isAT) {
    return null;
  }
  return !hasSeenWelcomeDialog && /*#__PURE__*/_jsx(CrmObjectBoardCardWelcomeDialog, {
    onClose: handleClose,
    userOnly: false
  });
};